export default "/images/alka.png?7e09ed5f6e9f1268090483216a0ec400";